import { createApi } from "@reduxjs/toolkit/query/react";
import { complianceFetchBase } from "../customFetchBase";

// The compliance engine (crosspoint-compliance on Cloud Run) — serving the
// Leads CRM until the institutional backend implements /leads and fans out to
// it. Separate host + x-api-key auth, hence its own api slice; endpoints are
// injected from leads_api.tsx.
export const complianceApi = createApi({
  reducerPath: "compliance",
  tagTypes: ["Leads", "ClientRegistry", "ComplianceClients", "ComplianceCase",
    "LpbList", "LpbRuns"],
  baseQuery: complianceFetchBase(),
  endpoints: () => ({}),
});
